module.exports = __webpack_public_path__ + "6259e9b893bd25ad389e9c77119a36d6.woff2";